import type { WorkerPosition } from "./positions";
import type { VenueType } from "./venues";

/**
 * Worker positions grouped by functional area (FE display).
 * Mỗi venue type sẽ enable/highlight 1 set group khác nhau.
 */
export const POSITION_GROUPS: Array<{
  key: string;
  label: string;
  positions: readonly WorkerPosition[];
}> = [
  {
    key: "FRONT_OF_HOUSE",
    label: "Phục vụ & Pha chế",
    positions: [
      "WAITER",
      "FOOD_RUNNER",
      "HOST",
      "BARTENDER",
      "BAR_BACK",
      "BARISTA",
      "BEVERAGE",
      "RECEPTIONIST",
    ],
  },
  {
    key: "KITCHEN",
    label: "Bếp",
    positions: [
      "HEAD_CHEF",
      "KITCHEN_SUPERVISOR",
      "HOT_KITCHEN",
      "HOT_KITCHEN_HELPER",
      "COLD_KITCHEN",
      "COLD_KITCHEN_HELPER",
      "COOK",
      "KITCHEN_STAFF",
      "KITCHEN_HELPER",
      "BAKER",
      "DISHWASHER",
    ],
  },
  {
    key: "OPERATIONS",
    label: "Vận hành",
    positions: [
      "CASHIER",
      "DELIVERY",
      "SECURITY",
      "PARKING",
      "CLEANER",
      "STOCK_KEEPER",
    ],
  },
  {
    key: "MANAGEMENT",
    label: "Quản lý",
    positions: [
      "MANAGER",
      "SHIFT_LEADER",
      "SUPERVISOR",
      "TRAINER",
      "MARKETING",
    ],
  },
];

/**
 * Suggested groups per venue type — group lên đầu khi employer chọn venue.
 * Còn lại groups vẫn hiện nhưng dim hơn.
 */
export const VENUE_PRIORITY_GROUPS: Record<VenueType, readonly string[]> = {
  RESTAURANT: ["FRONT_OF_HOUSE", "KITCHEN", "MANAGEMENT", "OPERATIONS"],
  CAFE: ["FRONT_OF_HOUSE", "OPERATIONS", "MANAGEMENT"],
  BAR_PUB: ["FRONT_OF_HOUSE", "MANAGEMENT", "OPERATIONS"],
  HOTPOT_BBQ: ["FRONT_OF_HOUSE", "KITCHEN", "MANAGEMENT", "OPERATIONS"],
  FAST_FOOD: ["FRONT_OF_HOUSE", "OPERATIONS", "KITCHEN", "MANAGEMENT"],
  BAKERY: ["KITCHEN", "FRONT_OF_HOUSE", "OPERATIONS"],
  OTHER: ["FRONT_OF_HOUSE", "KITCHEN", "OPERATIONS", "MANAGEMENT"],
};

/** Default min age for labor law compliance (Vietnam). */
export const DEFAULT_MIN_LABOR_AGE = 18;
